exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.main-block[data-v-1003eb4e] {\n    border: 1px solid #e4e4e4;\n    border-radius: 3px;\n    padding: 11px;\n}\n", ""]);

// exports
